import 'slick-carousel';
import 'sass-to-js/js/dist/sass-to-js.min.js';

export default (function() {
	let _$carousel = null;
	let _breakpoints;

	function init($carousel) {
		_$carousel = $carousel;
		_breakpoints = $('.js-breakpoint-sniffer').sassToJs({pseudoEl: '::after', cssProperty: 'content'});

		if ($carousel.length > 0) {
			$carousel.each(initCarousel);
		}

		onResize();
		$(window).on('resize', () => {
			onResize();
		});
		imageLoaded();
	}

	function initCarousel(index,carousel) {
		let _$nav = $(carousel).siblings('.js-carousel-nav');
		let _$counter = _$nav.find('.js-carousel-counter');

		$(carousel).on('init', function(event, slick){
			setCounter(_$counter, slick.currentSlide, slick.slideCount);
		});

		$(carousel).slick({
			cssEase       : 'cubic-bezier(0.15, 0, 0, 1)',
			infinite      : false,
			speed         : 500,
			fade          : false,
			dots          : false,
			adaptiveHeight: false,
			variableWidth : true,
			appendArrows: _$nav,
			prevArrow   : '<a class="slick-prev slick-arrow" href="#"><i class="icon icon-chevron-left" aria-hidden="true"></i></a>',
			nextArrow   : '<a class="slick-next slick-arrow" href="#"><i class="icon icon-chevron-right" aria-hidden="true"></i></a>',
		});
		$(carousel).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			setCounter(_$counter, nextSlide, slick.slideCount);
		});
	}

	// slick slider resize is broken, and can only work with pixel dimensions on its container
	function onResize() {
		if (!_$carousel) {
			return;
		}

		_$carousel.each(function(){
			$(this).css({
				'width' : '',
				'height': ''
			});
		});

		_$carousel.each(function() {
			$(this).css({
				'width' : $(this).parent().width()
			});
		});
		constrainHeight();
	}

	function imageLoaded() {
		_$carousel.each(function(){
			const imgs = $(this).find('img');
			$(imgs).each(function() {
				$(this).on('load', constrainHeight);
			})
		});
	}

	function constrainHeight() {
		if (!_$carousel) {
			return;
		}

		_$carousel.each(function(){
			const imgs = [...$(this).find('img')];
			$(imgs).css({
				'max-height' : ''
			});
			const heights = imgs.map(img => $(img).height()).filter(h => h > 0);
			const min = Math.min(...heights);
			$(imgs).css({
				'max-height' : `${min}px`
			});
		});
	}

	function setCounter(el, count, total) {
		$(el).text(`${count + 1} / ${total}`);
	}

	return {
		init,
	};
})();